import React from 'react';

import CasinoDashboard from './casino/pages/Dashboard/CasinoDashboard';
import DepositBonusCreate from './casino/pages/DepositBonus/DepositBonusCreate';
import DepositBonusEdit from './casino/pages/DepositBonus/DepositBonusEdit';
import DepositBonusList from './casino/pages/DepositBonus/DepositBonusList';
import DepositBonusShow from './casino/pages/DepositBonus/DepositBonusShow';
import DepositBonusPageCreate from './casino/pages/DepositBonusPage/DepositBonusPageCreate';
import DepositBonusPageEdit from './casino/pages/DepositBonusPage/DepositBonusPageEdit';
import DepositBonusPageShow from './casino/pages/DepositBonusPage/DepositBonusPageShow';
import DepositBonusPagesList from './casino/pages/DepositBonusPage/DepositBonusPagesList';
import GameCategoryCreate from './casino/pages/GameCategories/GameCategoryCreate';
import GameCategoryEdit from './casino/pages/GameCategories/GameCategoryEdit';
import GameCategoryList from './casino/pages/GameCategories/GameCategoryList';
import GameCategoryShow from './casino/pages/GameCategories/GameCategoryShow';
import { CRM_PERMISSION } from './casino/pages/Helpers/CrmPermissions';
import {
    CASINO_DASHBOARD,
    CASINO_DEPOSIT_BONUSES,
    CASINO_DEPOSIT_BONUS_PAGES,
    CASINO_FREESPIN_CAMPAIGNS,
    CASINO_FREESPIN_CAMPAIGN_CREATE,
    CASINO_FREESPIN_CAMPAIGN_SHOW,
    CASINO_FREESPIN_PAGES,
    CASINO_FREESPIN_PAGES_CREATE,
    CASINO_FREESPIN_PAGES_EDIT,
    CASINO_FREESPIN_PAGES_SHOW,
    CASINO_GAME_CATEGORY,
    CASINO_GAME_CATEGORY_BLOCKS,
    CASINO_GAME_CATEGORY_BLOCKS_CREATE,
    CASINO_GAME_CATEGORY_BLOCKS_EDIT,
    CASINO_GAME_CATEGORY_CREATE,
    CASINO_GAME_CATEGORY_EDIT,
    CASINO_GAME_CATEGORY_SHOW,
    CASINO_GAME_CREATORS,
    CASINO_GAME_CREATORS_GAME_EDIT,
    CASINO_GAME_CREATORS_SEO_CREATE,
    CASINO_GAME_CREATORS_SEO_EDIT,
    CASINO_GAME_CREATORS_SEO_SHOW,
    CASINO_GAME_CREATORS_SHOW,
    CASINO_GAME_CREATOR_GGR_REPORT,
    CASINO_GAME_GGR_REPORT,
    CASINO_SETTINGS,
    CASINO_SETTINGS_GAMES,
    CASINO_SETTINGS_LOGO,
    CASINO_NEWS_GAMES_WIDGET,
    CASINO_SETTINGS_TEMPLATE,
    CASINO_TOURNAMENTS,
    CASINO_TOURNAMENTS_CREATE,
    CASINO_TOURNAMENTS_EDIT,
    CASINO_TOURNAMENTS_EDIT_GAMES,
    CASINO_TOURNAMENTS_SHOW,
    CASINO_TRANSACTIONS,
    CASINO_SLIDERS,
    CASINO_TRANSACTIONS_BETS,
} from './casino/pages/Helpers/CrmUrls';
import NewsGamesWidget from './casino/pages/News/NewsGamesWidget';
import CasinoSettingsList from './casino/pages/Settings/CasinoSettingsList';
import GamesSetting from './casino/pages/Settings/Games/GamesSetting';
import LogoSetting from './casino/pages/Settings/Template/LogoSetting';
import TemplateSettings from './casino/pages/Settings/Template/TemplateSettings';
import BetsList from './casino/pages/Transactions/BetsList';
import TransactionsList from './casino/pages/Transactions/TransactionsList';
import FreespinCampaignCreate from './casino/pages/campaigns/FreespinCampaignCreate';
import FreespinCampaignEdit from './casino/pages/campaigns/FreespinCampaignEdit';
import FreespinCampaignShow from './casino/pages/campaigns/FreespinCampaignShow';
import FreespinCampaignsList from './casino/pages/campaigns/FreespinCampaignsList';
import GameCategoryBlockCreate from './casino/pages/categoryBlocks/GameCategoryBlockCreate';
import GameCategoryBlockEdit from './casino/pages/categoryBlocks/GameCategoryBlockEdit';
import GameCategoryBlockList from './casino/pages/categoryBlocks/GameCategoryBlockList';
import FreespinPageCreate from './casino/pages/freespinPage/FreespinPageCreate';
import FreespinPageEdit from './casino/pages/freespinPage/FreespinPageEdit';
import FreespinPageShow from './casino/pages/freespinPage/FreespinPageShow';
import FreespinPagesList from './casino/pages/freespinPage/FreespinPagesList';
import GameCreatorGameEdit from './casino/pages/gameCreators/GameCreatorGameEdit';

import GameCreatorShow from './casino/pages/gameCreators/GameCreatorShow';
import GameCreatorsList from './casino/pages/gameCreators/GameCreatorsList';

import GameCreatorSeo from './casino/pages/gameCreators/Seo/GameCreatorSeo';
import GameCreatorSeoCreate from './casino/pages/gameCreators/Seo/GameCreatorSeoCreate';
import GameCreatorSeoList from './casino/pages/gameCreators/Seo/GameCreatorSeoList';
import ReportGGRPerGame from './casino/pages/reports/ReportGGRPerGame';
import ReportGGRPerGameCreator from './casino/pages/reports/ReportGGRPerGameCreator';
import TournamentCreate from './casino/pages/tournaments/TournamentCreate';
import TournamentEdit from './casino/pages/tournaments/TournamentEdit';
import TournamentEditGames from './casino/pages/tournaments/TournamentEditGames';
import TournamentShow from './casino/pages/tournaments/TournamentShow';
import TournamentsList from './casino/pages/tournaments/TournamentsList';
import ProtectedRoute from './helpers/ProtectedRoute';
import SliderItemCreate from './pages/casinoSliders/SliderItemCreate';
import SliderItemEdit from './pages/casinoSliders/SliderItemEdit';
import SlidersList from './pages/casinoSliders/SliderList';
import SliderShow from './pages/casinoSliders/SliderShow';

function CasinoRootComponent() {
    return (
        <>
            <ProtectedRoute
                key="freespin-campaigns"
                exact
                path={CASINO_FREESPIN_CAMPAIGNS}
                pageName="Freespin campaigns"
                permissions={[CRM_PERMISSION.CASINO_FREESPIN_CAMPAIGNS_INDEX]}
            >
                <FreespinCampaignsList />
            </ProtectedRoute>

            <ProtectedRoute
                key="freespin-campaigns-create"
                exact
                path={CASINO_FREESPIN_CAMPAIGN_CREATE}
                pageName="Create freespin campaign"
                permissions={[CRM_PERMISSION.CASINO_FREESPIN_CAMPAIGNS_CREATE]}
            >
                <FreespinCampaignCreate />
            </ProtectedRoute>

            <ProtectedRoute
                key="freespin-campaigns-show"
                exact
                path={CASINO_FREESPIN_CAMPAIGN_SHOW}
                pageName="Show freespin campaign"
                permissions={[CRM_PERMISSION.CASINO_FREESPIN_CAMPAIGNS_SHOW]}
            >
                <FreespinCampaignShow />
            </ProtectedRoute>

            <ProtectedRoute
                key="freespin-campaigns-edit"
                exact
                path="/freespin-campaigns/:id/edit"
                pageName="Edit freespin campaign"
                permissions={[CRM_PERMISSION.CASINO_FREESPIN_CAMPAIGNS_EDIT]}
            >
                <FreespinCampaignEdit />
            </ProtectedRoute>

            <ProtectedRoute
                key="reports-ggr-per-game-show"
                exact
                path={CASINO_GAME_GGR_REPORT}
                pageName="Show GGR per game"
                permissions={[CRM_PERMISSION.REPORTS_GGR_INDEX]}
            >
                <ReportGGRPerGame />
            </ProtectedRoute>

            <ProtectedRoute
                key="reports-ggr-per-game-creator-show"
                exact
                path={CASINO_GAME_CREATOR_GGR_REPORT}
                pageName="Show GGR per game creator"
                permissions={[CRM_PERMISSION.REPORTS_GGR_INDEX]}
            >
                <ReportGGRPerGameCreator />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-categories-index"
                exact
                path={CASINO_GAME_CATEGORY}
                pageName="Game categories"
                permissions={[CRM_PERMISSION.GAME_CATEGORIES_INDEX]}
            >
                <GameCategoryList />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-categories-create"
                exact
                path={CASINO_GAME_CATEGORY_CREATE}
                pageName="Create game category"
                permissions={[CRM_PERMISSION.GAME_CATEGORY_CREATE]}
            >
                <GameCategoryCreate />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-category-show"
                exact
                path={CASINO_GAME_CATEGORY_SHOW}
                pageName="Game category"
                permissions={[CRM_PERMISSION.GAME_CATEGORY_SHOW]}
            >
                <GameCategoryShow />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-category-edit"
                exact
                path={CASINO_GAME_CATEGORY_EDIT}
                pageName="Edit game category"
                permissions={[CRM_PERMISSION.GAME_CATEGORY_EDIT]}
            >
                <GameCategoryEdit />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-category-blocks-index"
                exact
                path={CASINO_GAME_CATEGORY_BLOCKS}
                pageName="Game category blocks"
                permissions={[CRM_PERMISSION.GAME_CATEGORY_BLOCKS_INDEX]}
            >
                <GameCategoryBlockList />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-category-blocks-create"
                exact
                path={CASINO_GAME_CATEGORY_BLOCKS_CREATE}
                pageName="Create game category block"
                permissions={[CRM_PERMISSION.GAME_CATEGORY_BLOCKS_CREATE]}
            >
                <GameCategoryBlockCreate />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-category-blocks-edit"
                exact
                path={CASINO_GAME_CATEGORY_BLOCKS_EDIT}
                pageName="Edit game category block"
                permissions={[CRM_PERMISSION.GAME_CATEGORY_BLOCKS_EDIT]}
            >
                <GameCategoryBlockEdit />
            </ProtectedRoute>

            <ProtectedRoute
                key="tournaments"
                exact
                path={CASINO_TOURNAMENTS}
                pageName="Tournaments list"
                permissions={[CRM_PERMISSION.TOURNAMENT_INDEX]}
            >
                <TournamentsList />
            </ProtectedRoute>

            <ProtectedRoute
                key="tournaments-create"
                exact
                path={CASINO_TOURNAMENTS_CREATE}
                pageName="Create tournament"
                permissions={[CRM_PERMISSION.TOURNAMENT_CREATE]}
            >
                <TournamentCreate />
            </ProtectedRoute>

            <ProtectedRoute
                key="tournaments-edit"
                exact
                path={CASINO_TOURNAMENTS_EDIT}
                pageName="Edit tournament"
                permissions={[CRM_PERMISSION.TOURNAMENT_EDIT]}
            >
                <TournamentEdit />
            </ProtectedRoute>

            <ProtectedRoute
                key="tournaments-edit-games"
                exact
                path={CASINO_TOURNAMENTS_EDIT_GAMES}
                pageName="Edit tournament games"
                permissions={[CRM_PERMISSION.TOURNAMENT_EDIT]}
            >
                <TournamentEditGames />
            </ProtectedRoute>

            <ProtectedRoute
                key="tournaments-show"
                exact
                path={CASINO_TOURNAMENTS_SHOW}
                pageName="Show tournament"
                permissions={[CRM_PERMISSION.TOURNAMENT_SHOW]}
            >
                <TournamentShow />
            </ProtectedRoute>

            <ProtectedRoute
                key="freespin-pages"
                exact
                path={CASINO_FREESPIN_PAGES}
                pageName="Bonus pages list"
                permissions={[CRM_PERMISSION.FREESPIN_PAGE_INDEX]}
            >
                <FreespinPagesList />
            </ProtectedRoute>

            <ProtectedRoute
                key="freespin-pages-create"
                exact
                path={CASINO_FREESPIN_PAGES_CREATE}
                pageName="Create bonus page"
                permissions={[CRM_PERMISSION.FREESPIN_PAGE_CREATE]}
            >
                <FreespinPageCreate />
            </ProtectedRoute>

            <ProtectedRoute
                key="freespin-pages-edit"
                exact
                path={CASINO_FREESPIN_PAGES_EDIT}
                pageName="Edit bonus page"
                permissions={[CRM_PERMISSION.FREESPIN_PAGE_EDIT]}
            >
                <FreespinPageEdit />
            </ProtectedRoute>

            <ProtectedRoute
                key="freespin-pages-show"
                exact
                path={CASINO_FREESPIN_PAGES_SHOW}
                pageName="Show bonus page"
                permissions={[CRM_PERMISSION.FREESPIN_PAGE_SHOW]}
            >
                <FreespinPageShow />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-creators"
                exact
                path={CASINO_GAME_CREATORS}
                pageName="Game creators"
                permissions={[CRM_PERMISSION.GAME_CREATORS_INDEX]}
            >
                <GameCreatorsList />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-creators-show"
                exact
                path={CASINO_GAME_CREATORS_SHOW}
                pageName="Show game creator"
                permissions={[CRM_PERMISSION.GAME_CREATORS_SHOW]}
            >
                <GameCreatorShow />
            </ProtectedRoute>

            <ProtectedRoute
                key="game-creators-game-edit"
                exact
                path={CASINO_GAME_CREATORS_GAME_EDIT}
                pageName="Edit game"
                permissions={[CRM_PERMISSION.GAME_EDIT]}
            >
                <GameCreatorGameEdit />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-settings"
                exact
                path={CASINO_SETTINGS}
                pageName="Casino settings"
                permissions={[CRM_PERMISSION.CASINO_SETTINGS_INDEX]}
            >
                <CasinoSettingsList />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-games-setting-edit"
                exact
                path={CASINO_SETTINGS_GAMES}
                pageName="Edit casino games settings"
                permissions={[CRM_PERMISSION.CASINO_SETTINGS_GAMES_EDIT]}
            >
                <GamesSetting />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-logo-setting-edit"
                exact
                path={CASINO_SETTINGS_LOGO}
                pageName="Edit casino logo"
                permissions={[CRM_PERMISSION.CASINO_SETTINGS_TEMPLATE_EDIT]}
            >
                <LogoSetting />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-template-settings-edit"
                exact
                path={CASINO_SETTINGS_TEMPLATE}
                pageName="Edit casino template settings"
                permissions={[CRM_PERMISSION.CASINO_SETTINGS_TEMPLATE_EDIT]}
            >
                <TemplateSettings />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-game-creator-seo-create"
                exact
                path={CASINO_GAME_CREATORS_SEO_CREATE}
                pageName="Create casino provider seo settings"
                permissions={[CRM_PERMISSION.CREATE_CASINO_GAME_CREATOR_SEO]}
            >
                <GameCreatorSeoCreate />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-game-creator-seo-edit"
                exact
                path={CASINO_GAME_CREATORS_SEO_EDIT}
                pageName="Edit casino provider seo settings"
                permissions={[CRM_PERMISSION.EDIT_CASINO_GAME_CREATOR_SEO]}
            >
                <GameCreatorSeo />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-game-creator-seo-show"
                exact
                path={CASINO_GAME_CREATORS_SEO_SHOW}
                pageName="Show casino provider seo settings"
                permissions={[CRM_PERMISSION.INDEX_CASINO_GAME_CREATOR_SEO]}
            >
                <GameCreatorSeoList />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-dashboard"
                exact
                path={CASINO_DASHBOARD}
                pageName="Casino dashboard"
                permissions={[CRM_PERMISSION.CASINO_DASHBOARD_INDEX]}
            >
                <CasinoDashboard />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-sliders"
                exact
                path={CASINO_SLIDERS}
                pageName="Casino Sliders"
                permissions={[CRM_PERMISSION.CASINO_SLIDERS_VIEW]}
            >
                <SlidersList />
            </ProtectedRoute>
            <ProtectedRoute
                key="casino-slider-view"
                exact
                path="/casino-slider/:id"
                pageName="View Casino Slider"
                permissions={[CRM_PERMISSION.CASINO_SLIDER_VIEW]}
            >
                <SliderShow />
            </ProtectedRoute>
            <ProtectedRoute
                key="casino-sliders-item-create"
                exact
                path="/casino-slider/:id/create"
                pageName="Create Casino Slider Item"
                permissions={[CRM_PERMISSION.CASINO_SLIDER_ITEM_CREATE]}
            >
                <SliderItemCreate />
            </ProtectedRoute>
            <ProtectedRoute
                key="casino-sliders-item-edit"
                exact
                path="/casino_slider_item/:id"
                pageName="Edit Casino Slider Item"
                permissions={[CRM_PERMISSION.CASINO_SLIDER_ITEM_EDIT]}
            >
                <SliderItemEdit />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-deposit-bonus-page-create"
                exact
                path={`${CASINO_DEPOSIT_BONUS_PAGES}/create`}
                pageName="Create casino deposit bonus page"
                permissions={[CRM_PERMISSION.CREATE_DEPOSIT_BONUS_PAGE]}
            >
                <DepositBonusPageCreate />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-deposit-bonus-pages"
                exact
                path={CASINO_DEPOSIT_BONUS_PAGES}
                pageName="Deposit bonus pages"
                permissions={[CRM_PERMISSION.INDEX_DEPOSIT_BONUS_PAGE]}
            >
                <DepositBonusPagesList />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-deposit-bonus-page-edit"
                exact
                path={`${CASINO_DEPOSIT_BONUS_PAGES}/:id/edit`}
                pageName="edit deposit bonus pages"
                permissions={[CRM_PERMISSION.EDIT_DEPOSIT_BONUS_PAGE]}
            >
                <DepositBonusPageEdit />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-deposit-bonus-page-show"
                exact
                path={`${CASINO_DEPOSIT_BONUS_PAGES}/show/:id`}
                pageName="show deposit bonus pages"
                permissions={[CRM_PERMISSION.SHOW_DEPOSIT_BONUS_PAGE]}
            >
                <DepositBonusPageShow />
            </ProtectedRoute>

            <ProtectedRoute
                key="deposit-bonuses"
                exact
                path={CASINO_DEPOSIT_BONUSES}
                pageName="Deposit bonuses"
                permissions={[CRM_PERMISSION.DEPOSIT_BONUS_INDEX]}
            >
                <DepositBonusList />
            </ProtectedRoute>

            <ProtectedRoute
                key="deposit-bonuses-create"
                exact
                path={`${CASINO_DEPOSIT_BONUSES}/create`}
                pageName="Create deposit bonus"
                permissions={[CRM_PERMISSION.DEPOSIT_BONUS_CREATE]}
            >
                <DepositBonusCreate />
            </ProtectedRoute>

            <ProtectedRoute
                key="deposit-bonuses-show"
                exact
                path={`${CASINO_DEPOSIT_BONUSES}/show/:id`}
                pageName="Show deposit bonus"
                permissions={[CRM_PERMISSION.DEPOSIT_BONUS_INDEX]}
            >
                <DepositBonusShow />
            </ProtectedRoute>

            <ProtectedRoute
                key="deposit-bonuses-edit"
                exact
                path={`${CASINO_DEPOSIT_BONUSES}/:id/edit`}
                pageName="Edit deposit bonus"
                permissions={[CRM_PERMISSION.DEPOSIT_BONUS_EDIT]}
            >
                <DepositBonusEdit />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-transactions-view"
                exact
                path={CASINO_TRANSACTIONS}
                pageName="Casino sessions"
                permissions={[CRM_PERMISSION.CASINO_TRANSACTIONS_VIEW]}
            >
                <TransactionsList />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-transactions-bets"
                exact
                path={CASINO_TRANSACTIONS_BETS}
                pageName="Session bets"
                permissions={[CRM_PERMISSION.CASINO_TRANSACTIONS_VIEW]}
            >
                <BetsList />
            </ProtectedRoute>

            <ProtectedRoute
                key="casino-news-games-widget-view"
                exact
                path={CASINO_NEWS_GAMES_WIDGET}
                pageName="Edit casino news games widget"
                permissions={[CRM_PERMISSION.NEWS_GAMES_WIDGET_INDEX]}
            >
                <NewsGamesWidget />
            </ProtectedRoute>
        </>
    );
}

export default CasinoRootComponent;
